// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/utc-zulu-basics.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/utc-zulu-basics/utc-zulu-basics.js';

mount([g0]);
